/**
 * Каким видом человек смотрит график отклика.
 *
 * Два вида показывают одни и те же данные, но отвечают на разные вопросы.
 * Столбики — про проверки: их видно поштучно, и провал в середине часа
 * читается как выломанный зуб. Линия — про ход: по ней заметно, что отклик
 * весь час полз вверх, а по частоколу столбиков это разглядеть трудно.
 * Что важнее, знает не платформа, а тот, кто разбирается с узлом.
 *
 * Выбор общий на все графики сразу и живёт в браузере: это привычка
 * читающего, а не свойство монитора, и щёлкать переключателем у каждого
 * монитора по отдельности — работа на ровном месте.
 */

const RTT_VIEW_KEY = 'netdeck.monitor.rtt-view';

export const RTT_VIEWS = ['bars', 'line'] as const;

export type RttView = (typeof RTT_VIEWS)[number];

/** По умолчанию столбики: так график нарисован в макете (раздел 03). */
export function readRttView(): RttView {
  try {
    return localStorage.getItem(RTT_VIEW_KEY) === 'line' ? 'line' : 'bars';
  } catch {
    // Хранилище недоступно — приватный режим, запрет сторонних данных.
    return 'bars';
  }
}

export function writeRttView(view: RttView): void {
  try {
    localStorage.setItem(RTT_VIEW_KEY, view);
  } catch {
    // Не сохранилось — переживём: на текущем экране вид уже переключён.
  }
}
